export default __webpack_public_path__ + "static/hc-3807f72f57e535aa4f1f5e900e5e775d.jpg";